/* eslint-disable
    no-alert,
    react/prefer-stateless-function,
    react/prop-types
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import classNames from 'classnames';
import $ from 'jquery';

import PropTypes from 'prop-types';

import React from 'react';
import createReactClass from 'create-react-class';
import {CSSTransitionGroup} from 'react-transition-group';
import _ from 'underscore';
import * as TransitionConstants from 'ui-library/TransitionConstants';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import EditableListMixin from 'notebook/mediocre/selection/text/EditableListMixin';
import TimerComponent from 'notebook/protocols/viewer/TimerComponent';
import TimeEditable from 'notebook/protocols/editor/TimeEditable';

class SingleTimer extends React.Component {
  static propTypes = {
    inlineCopy: PropTypes.bool.isRequired,
    name: PropTypes.string.isRequired,
    requestChange: PropTypes.func.isRequired,
    requestDelete: PropTypes.func.isRequired,
  };

  promptName = () => {
    const newName = prompt('Enter a name for this timer:') || '';
    if (newName) {
      this.props.requestChange({name: newName});
    }
  };

  render() {
    return (
      <div className={classNames('timer-block', {'inline-copy': this.props.inlineCopy})}>
        <div className="close pull-right" onClick={this.props.requestDelete}>
          ×
        </div>
        <div className="timer-name" onClick={this.promptName}>
          {this.props.name}
        </div>
        <TimerComponent {...this.props} />
      </div>
    );
  }
}

const DEFAULT_TIMER_MS = 60 * 1000;

const CreateTimerBlock = createReactClass({
  getInitialState() {
    return {
      showingForm: this.props.createTimerPrefill != null,
      name: (this.props.createTimerPrefill != null ? this.props.createTimerPrefill.name : undefined) || '',
      originalMS:
        (this.props.createTimerPrefill != null ? this.props.createTimerPrefill.originalMS : undefined) ||
        DEFAULT_TIMER_MS,
    };
  },

  propTypes: {
    createTimer: PropTypes.func.isRequired,
  },

  mixins: [EditableListMixin],

  showForm() {
    return this.setState({showingForm: true});
  },

  resetForm() {
    return this.setState({
      showingForm: false,
      name: '',
      originalMS: DEFAULT_TIMER_MS,
    });
  },

  setName(e) {
    return this.setState({name: $(e.currentTarget).val()});
  },

  createTimer(e) {
    e.preventDefault();
    const name = this.state.name.length === 0 ? 'New Timer' : this.state.name;
    this.props.createTimer(name, this.state.originalMS);
    this.resetForm();
  },

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.createTimerPrefill) {
      this.setState({
        showingForm: true,
        name: nextProps.createTimerPrefill.name,
        originalMS: nextProps.createTimerPrefill.originalMS,
      });
    }
  },

  updateTime(time, selection) {
    this.setState({originalMS: time * 1000});
    this.setSelection(selection);
  },

  render() {
    return (
      <div className="timer-block create-btn-block">
        {this.state.showingForm ? (
          <form onSubmit={this.createTimer}>
            <label>Timer Name</label>
            <input
              type="text"
              placeholder="New Timer"
              autoFocus={true}
              value={this.state.name}
              onChange={this.setName}
            />
            <label>Time (hh:mm:ss)</label>
            <TimeEditable
              updateTimeHandler={this.updateTime}
              time_seconds={this.state.originalMS / 1000}
              setSelection={this.setSelection}
            />
            <Button
              type="submit"
              buttonStyle={ButtonStyle.SECONDARY}
              size={ButtonSize.MEDIUM}
              text="Create"
              className="u-mini-spacing-right"
            />
            <Button
              buttonStyle={ButtonStyle.TERTIARY_GRAY}
              size={ButtonSize.MEDIUM}
              text="Cancel"
              onClick={this.resetForm}
            />
          </form>
        ) : (
          <button type="button" className="new-timer-btn" onClick={this.showForm}>
            <BenchlingIcon icon="plus-large" />
            {' Create Timer'}
          </button>
        )}
      </div>
    );
  },
});

class SBSTimers extends React.Component {
  static propTypes = {
    timers: PropTypes.array.isRequired,
    createTimer: PropTypes.func.isRequired,
    createTimerPrefill: PropTypes.object,
    onRequestClose: PropTypes.func.isRequired,
  };

  render() {
    const children = Array.from(this.props.timers).map((timer) => (
      // eslint-disable-next-line no-restricted-syntax
      <SingleTimer {..._.extend({key: timer.id}, timer)} />
    ));
    children.push(
      <CreateTimerBlock
        key="create-timer-block"
        createTimer={this.props.createTimer}
        createTimerPrefill={this.props.createTimerPrefill}
      />
    );
    return (
      <div className="sbs-timers">
        <CSSTransitionGroup
          component="div"
          transitionName="transition-fade"
          transitionEnterTimeout={TransitionConstants.TRANSITION_FADE_DURATION_MS}
          transitionLeaveTimeout={TransitionConstants.TRANSITION_FADE_DURATION_MS}
        >
          {children}
        </CSSTransitionGroup>
        <div className="close-timers-btn" onClick={this.props.onRequestClose}>
          <BenchlingIcon icon="chevron-up" />
          {' Hide timers '}
          <BenchlingIcon icon="chevron-up" />
        </div>
      </div>
    );
  }
}

export default SBSTimers;
